module.exports = __webpack_public_path__ + "img/IconControlBranco.b3a3a0b8.png";